const refrescarTienda = objeto => {
    return {
        type: 'refrescarSitio',
        payload: objeto
    }
}

module.exports = {
    refrescarTienda
}